export enum CleaningType {
    Stockage = 1,
    OutOfLine = 2,
}
